var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bounding_box",
    "data-name": "Bounding box"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.97736,12.15112l-3.466,1.15528-2.87323-2.87323,1.15527-3.466L7.19459,2.36835,5.49207,4.07074a7.74994,7.74994,0,0,0-1.61041,8.56891,14.54883,14.54883,0,0,0,3.05395,4.3692,14.54838,14.54838,0,0,0,4.36927,3.054,7.60237,7.60237,0,0,0,3.10345.65771,7.68071,7.68071,0,0,0,5.46539-2.26807l1.70252-1.70257Zm1.48218,4.88715a5.732,5.732,0,0,1-4.05121,1.68231,5.64221,5.64221,0,0,1-2.292-.48578,12.50915,12.50915,0,0,1-3.76642-2.64013,12.5095,12.5095,0,0,1-2.64014-3.76642A5.7046,5.7046,0,0,1,6.90626,5.485l.28827-.28827L9.50519,7.50739l-.836,2.508a1.63378,1.63378,0,0,0,.39471,1.672l3.19324,3.19324a1.63333,1.63333,0,0,0,1.672.39471l2.508-.836L18.74781,16.75Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.2e7e7d3c.svg";
export { ForwardRef as ReactComponent };